var detailValidationModelController = (function () {
    function detailValidationModelController(env, DTS, $stateParams, Dialog) {
        this.env = env;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.Dialog = Dialog;
    }
    detailValidationModelController.prototype.closeDialog = function () {
        this.Dialog.closeDialog();
    };
    detailValidationModelController.$inject = ['env', 'DTS', '$stateParams', 'Dialog'];
    return detailValidationModelController;
}());
angular
    .module('application')
    .controller('detailValidationModelController', detailValidationModelController);

//# sourceMappingURL=detail.validation.modal.controller.js.map
